<template>
  <div class="wrapper" id="wrapper">
    <div class="header">
      <!--返回|退出按钮-->
      <div class="go-back" @click="goBack" />
      <div class="top-title">抽奖活动</div>
      <div class="rule-btn" @click="ruleShow = !ruleShow">规则</div>
    </div>
    <div class="redpack-content">
      <!--图片标题-->
      <div class="title" />
      <!--跑马灯奖品区域-->
      <div class="prize-content">
        <div class="prize-item-list">
          <!--跑马灯奖品单元及抽奖按钮-->
          <div v-for="(item, index) in lotterys" :key="index" :class="item.class" @click="item.id == 0 ? startLottery(1): ''" >
            <span><img v-if="item.img != ''" :src="require('@/assets/images/member_prize/' + item.img + '.png')" /></span>
            <span>{{ item.title }}</span>
            <span>{{ item.intro }}</span>
            <span v-show="item.select === 1"></span>
          </div>
        </div>
      </div>
      <!--跑马灯奖品记录区域-->
      <div class="prize-record">
        <div class="prize-record-title"></div>
        <div class="prize-record-content">
          <div class="prize-record-top">奖励记录</div>
          <div class="prize-record-list">
            <!-- <vue-seamless-scroll
              :data="lottery_records"
              :class-option="seamlessScrollOption"
              style="height: 1.6rem;overflow:hidden;"
            > -->
            <div class="prize-record-list-box">
              <div v-for="(item, index) in lottery_records" :key="index"  class="prize-record-list-item">
                <span>{{ item.time }}</span>
                <span>{{ item.lottery_txt }}</span>
              </div>
            </div>
            <!-- </vue-seamless-scroll> -->
          </div>
        </div>
      </div>
    </div>

    <!--规则弹窗-->
    <van-popup v-model="ruleShow" :close-on-click-overlay=false>
      <div class="introduce">
        <div class="close" @click="ruleShow = false"/>
        <div class="rule_info">
          <div v-html="ruleTxt"/>
        </div>
      </div>
    </van-popup>

    <!--中奖弹窗-->
    <van-popup v-model="rewardShow" :close-on-click-overlay=false>
      <div class="reward-content">
        <div class="close" @click="resetVal()"/>
        <div class="reward-info">
          <span><img v-if="rewardInfo.img != ''" :src="require('@/assets/images/member_prize/' + rewardInfo.img + '.png')" /></span>
          <span>{{ rewardInfo.title }}</span>
          <span>{{ rewardInfo.subtitle }}</span>
          <span @click="startLottery(2)">继续抽奖</span>
          <span v-if="rewardInfo.jump_txt != ''" @click="toApp(rewardInfo.jump_url)">{{ rewardInfo.jump_txt }}</span>
        </div>
      </div>
    </van-popup>

    <!--视频加载中-->
    <van-popup v-model="rloadShow" :close-on-click-overlay=false>
      <div class="redpack-loading">
        <span><img src="~@/assets/images/day_redpack/rloading.png" /></span>
        <span>加载中…</span>
        <span>广告播放完毕即可开始抽奖</span>
      </div>
    </van-popup>

    <!--加载中-->
    <loading :isLoad="isLoad" />
  </div>
</template>

<script>
import Vue from "vue";
import { Popup, Toast } from "vant";
import VueSeamlessScroll from "vue-seamless-scroll"; // 垂直滚动插件

Vue.use(Popup).use(Toast);
Vue.use(VueSeamlessScroll);
import Loading from "@/components/Loading"; // 加载中组件
export default {
  name: "MemberPrize",
  components: {
    Loading
  },
  data() {
    return {
      tempIndex: 0, // 跑马灯初始位置 下次是上次的结束位置
      tempNum: 0, // 跑马灯初始位置数字索引 下次是上次的结束位置
      prizeId: 0, // 中奖的奖品ID
      setTime: undefined, // 跑马灯循环定时器
      lotterying: 0, // 是否抽奖中
      prize_draw_but: {
        title:'抽奖',
        subtitle:'本次免费',
        play_video_status: 0 // 0 不用播放视频 1 需要播放视频 2 不允许点击
      },  // 抽奖按钮状态及信息
      lotterys:[], // 奖品列表
      tempLotteryLabels: [], // 临时奖品列表
      lottery_imgs: [
        { title: '金币', img: 'coin' },
        { title: '白银会员', img: 'silver_vip' },
        { title: '黄金会员', img: 'gold_vip' },
        { title: '钻石会员', img: 'diamond_vip' },
        { title: '金额', img: 'money' },
        { title: '奖励卡', img: 'card' },
        { title: '随机奖励卡', img: 'card2' },
        { title: '红包', img: 'redpack' },
        { title: '谢谢惠顾', img: 'thanks' }
      ], // 奖品图片列表
      numArr: [0,1,2,5,8,7,6,3], // 跑马灯的循环顺序
      lottery_records: [], //抽奖记录
      temp_records: [], // 抽奖记录 临时
      rewardInfo: {
        img: 'thanks',
        id: 0,
        title: '',
        subtitle: '',
        lottery_type: 1, // 奖励类型 4 红包跳转到余额，2金币跳转到金币页面，5会员跳转到兑换页面 3奖励卡跳转到奖励卡页面 1谢谢惠顾不跳转
        jump_txt: '',
        jump_url: '',
      }, //  中奖信息
      wrapperWidth: 375,
      isLoad: false, // 加载中
      ruleShow: false, // 规则弹窗
      rloadShow: false, // 红包加载中弹窗
      rewardShow: false, // 中奖弹窗
      ruleTxt:"", // 活动规则
      tipsConfigTxt: "" // 激励视频浮窗提示文案
    };
  },
  computed: {
    // 记录滚动配置
    seamlessScrollOption() {
      return {
        step: 1.5, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: (this.wrapperWidth/375) * 80, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 500 // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    this.userid = this.getCookie("userid");
    if (this.$route.query.debug == 1) {
      this.userid = this.$route.query.userid;
    }
    // 获取抽奖数据
    this.getData(1);
  },
  mounted() {
    // 播放广告回调
    window.playH5AdResult = res => {
      console.log(res, "广告数据回调");
      this.rloadShow = false; // 隐藏加载框
      // 播放广告完成
      if (parseInt(res) == 1) {
        this.LotteryComplete(); // 广告播放成功 开始跑马灯抽奖
      } else {
        this.resetVal()
        this.toast("奖励领取失败:播放广告失败");
        setTimeout(() => {
          window.location.reload()
        }, 300);
      }
    };
    window.addEventListener('resize', this.getWindowResize, false) // 监听屏幕尺寸变化
  },
  methods: {
    // 监控屏幕尺寸变化
    getWindowResize () {
      let wrapper = document.getElementById('wrapper').getBoundingClientRect()
      this.wrapperWidth = wrapper.width
      console.log(this.wrapperWidth)
    },
    // 获取cookie值
    getCookie(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    // 调用客户端方法
    callClienFunc(fname, fval) {
      console.log(fname, fval, 111);
      if (window.hasOwnProperty("injectedObject")) {
        window.injectedObject.setJsContent(fname, JSON.stringify(fval));
      } else {
        fval = fval ? fval : {};
        let params = { method: fname, params: fval };
        params = JSON.stringify(params);
        window.Android.postMessage(params);
      }
    },
    // 关闭页面
    goBack() {
      this.callClienFunc("closeWebview", "");
    },
    // 跳转到app链接页面
    toApp(url) {
      window.location.href = url
    },
    // 自定义toast 样式自定义
    toast(message) {
      Toast({ message: message, className: "toast-spin-win" });
    },
    // 重置数据(关闭奖励结算弹窗)
    resetVal() {
      this.prizeId = 0 // 中奖ID重置为0
      this.rewardShow = false // 关闭结算弹窗
      this.rloadShow = false // 关闭加载中弹窗
      this.temp_records = [] // 将临时奖励记录设置为空
      // 最后一次抽奖 刷新数据
      let status = parseInt(this.prize_draw_but.play_video_status)
      if (status == 2) {
        this.getData(2)
      }
    },
    // 开始抽奖
    startLottery (type) {
      // 抽奖中 禁止重复操作
      if(this.lotterying === 1) 
      {
        return false;
      }
      this.lotterying = 1; // 开始抽奖就将抽奖中设置成进行中

      let status = parseInt(this.prize_draw_but.play_video_status)
      // 禁止抽奖状态
      if (status === 2) {
        this.lotterying = 0
        if (type == 2) {
          this.toast("您今天的抽奖次数已用完，请明天再来哦~"); //弹出错误信息
        }
        return false;
      }
      this.resetVal()

      // 如果是第一次 不用看视频 或者状态标注是否需要看视频
      if (status == 0) 
      {
        this.LotteryComplete()
      } else {
        // 播放激励视频广告
        this.showAds()
      }

      //this.LotteryComplete()
    },
    // 完成激励视频后 奖励领取 先查询奖励在运行跑马灯
    LotteryComplete () {
      let status = parseInt(this.prize_draw_but.play_video_status)
      // 禁止抽奖状态
      if (status === 2) {
        return false;
      }
      let params = {
        userid: this.userid,
      };
      // http://gametest.lushihudong.com/api/user_web/day_red_envelopes_index
      // http://game.lushihudong.com
      this.isLoad = true;
      this.$http
        .get(
          "http://game.lushihudong.com/api/user_web/prize_draw",
          {
            params: params
          }
        )
        .then(res => {
          if (res.code == 1) {
            let tempData = res.data.settlement_template
            this.prizeId = parseInt(tempData.id) // 中奖奖品ID
            let index = this.lotterys.findIndex((item) => parseInt(item.id) === this.prizeId)
            let tempLottery = this.lotterys[index] // 找到中奖ID对应的奖品信息

            // 奖励信息 4 红包，2金币，5会员 3奖励卡 1谢谢惠顾
            let temp_lottery_type = parseInt(tempData.lottery_type);
            let temp_jump_txt = ''; // 查看按钮文字
            let temp_jump_url = ''; // 跳转地址
            switch(temp_lottery_type) {
              case 4:
                temp_jump_txt = '去看看';
                temp_jump_url = tempData.jump_url;
                break;
              case 2:
                temp_jump_txt = '去看看';
                temp_jump_url = tempData.jump_url;
                break;
              case 3:
                temp_jump_txt = '去看看';
                temp_jump_url = tempData.jump_url;
                break;
              case 5:
                temp_jump_txt = '去兑换';
                temp_jump_url = tempData.jump_url;
                break;
              default:
                break;
            }

            // 奖励信息
            this.rewardInfo = {
              img: this.getLotteryImg(tempLottery.image),
              id: this.prizeId,
              title: tempData.reward_txt ? tempData.reward_txt : tempLottery.title,
              subtitle: tempData.subtitle,
              lottery_type: temp_lottery_type,
              jump_txt : temp_jump_txt,
              jump_url: temp_jump_url,
            }

            // 更新奖品和按钮状态
            this.getData(2)

            // 运行跑马灯
            this.runLottery2()

          } else {
            this.toast("数据查询失败:" + res.message); //弹出错误信息
          }
          this.isLoad = false;
        });
    },
    // 启动抽奖跑马灯 (按顺时针跑 不按照数字从小到大跑)
    runLottery2 () {

      let that = this
      if (that.prizeId <= 0 || that.prizeId == '') {
        that.toast("系统错误,请重新抽奖"); // 没有奖品 则报错 不跑
        return false;
      }

      // 防止重复抽奖
      if (that.setTime){
        that.toast("抽奖中，请勿重复点击");
        return false;
      }
      let count = 0; // 跑马灯跑的总次数
      
      // 跑马灯起始位置索引 (为第一个或上一次结束的位置)
      let index = 0
      let num = that.tempNum

      //定时器开始
      that.setTime = setInterval(function(){
          // 如果到最后一个奖品还未结束抽奖  则重置继续跑马灯
          if(num > 7){
            let tempEndIndex = that.numArr[num -1] // 最后一个奖品的索引
            that.setLotteryItemSelect(tempEndIndex, 0) // 设置未选中
            num = 0 // 重置数字索引到起始位置
          }

          // 奖品的状态 当前选中 上一个未选中
          let indexPre = 0
          index = that.numArr[num]
          if (num > 0) {
            indexPre = that.numArr[num - 1]
            that.setLotteryItemSelect(indexPre, 0) // 设置未选中
          }
          // 将当前跑跑马灯修改成选中状态

          that.setLotteryItemSelect(index, 1) // 设置当前选中

          // 数字索引+1
          num++;

          //总计数器+1
          count++;

          index = that.numArr[num]
          indexPre = that.numArr[num - 1]
          
          // 因为已经加1 所以选中的奖品应该是index-1的ID
          let selectId = parseInt(that.lotterys[indexPre].id);

          // 有预设奖品
          if(that.prizeId > 0){
              // 至少跑35下，跑到预设的奖品就停下
              if(count>35 && selectId === that.prizeId ){
                  // 清除定时器
                  clearInterval(that.setTime); 
                  // 弹出中奖弹窗
                  if(that.lotterys[indexPre].select === 1){
                    that.tempNum = num - 1
                    that.showReward()
                  }
                  that.setTime = undefined;
              }
              //中断程序运行，防止走预设奖品后的代码
              return false;
          }

          // 没有预设奖品的算法，跑20次后随机获得奖品 这种情况暂时不允许发生 prizeId 必须大于0
          if(count>35 && parseInt(Math.random()*10)>8 ) {
              clearInterval(that.setTime);
              //弹出奖品的时候排除掉谢谢惠顾
              if(that.lotterys[indexPre].select === 1){
                // 弹出中奖弹窗
                that.tempNum = num - 1
                that.showReward()
              }
              that.setTime = undefined;
          }
      }, 80);
    },
    // 启动抽奖跑马灯 按照数字从小到大跑
    runLottery () {
      let that = this

      if (that.prizeId <= 0 || that.prizeId == '') {
        that.toast("系统错误,请重新抽奖"); // 没有奖品 则报错 不跑
        return false;
      }

      // 防止重复抽奖
      if (that.setTime){
        that.toast("抽奖中，请勿重复点击");
        return false;
      }
      let index = that.tempIndex; // 跑马灯起始位置 (为第一个或上一次结束的位置)
      let count = 0; // 跑马灯跑的次数
      //定时器开始

      that.setTime = setInterval(function(){
          // 如果是抽奖按钮跑马灯则跳过到下一个奖品
          if (index == 4) {
            index++;
          }
          // 从第二个跑马灯开始，每走一个跑马灯就把上一个跑马灯的样式恢复成未选中
          if(index > 0) {
            // 如果是抽奖按钮的位置 需要将上两个修改成未选中
            if (index == 5) {
              that.lotterys[index - 2].select = 0;
            } else {
              that.lotterys[index - 1].select = 0;
            }
          }
          //跑完最后一个跑马灯又从第一个重新开始跑
          if(index > 8){
              index = 0;
          }

          // 将当前跑跑马灯修改成选中状态
          that.lotterys[index].select = 1;

          //当前跑的跑马灯的下标+1
          index++;

          //总计数器+1
          count++;

          // 因为已经加1 所以选中的奖品应该是index-1的ID
          let selectId = parseInt(that.lotterys[index -1].id);

          // 有预设奖品
          if(that.prizeId > 0){
              // 至少跑30下，跑到预设的奖品就停下
              if(count>60 && selectId === that.prizeId ){
                  // 清除定时器
                  clearInterval(that.setTime); 
                  // 弹出中奖弹窗
                  if(that.lotterys[index -1].select === 1){
                    that.tempIndex = index - 1
                    that.showReward()
                  }
                  that.setTime = undefined;
              }
              //中断程序运行，防止走预设奖品后的代码
              return false;
          }

          // 没有预设奖品的算法，跑20次后随机获得奖品 这种情况暂时不允许发生 prizeId 必须大于0
          if(count>60 && parseInt(Math.random()*10)>8 ) {
              clearInterval(that.setTime);
              //弹出奖品的时候排除掉谢谢惠顾
              if(that.lotterys[index -1].select === 1){
                that.tempIndex = index - 1
                // 弹出中奖弹窗
                that.showReward()
              }
              that.setTime = undefined;
          }
      }, 80);
    },
    // 设置奖品的选中状态
    setLotteryItemSelect (index, select) {
      let tempItem = this.lotterys[index]
      tempItem.select = select
      this.$set(this.lotterys, index, tempItem)
    },
    // 显示奖励弹窗和记录
    showReward () {
      this.lotterying = 0;
      this.rewardShow = true
      // 弹窗出现后再更新记录显示
      this.lottery_records = this.temp_records
      // 更新奖品列表
      this.formatLottery(this.tempLotteryLabels)
    },
    // 获取奖品图片
    getLotteryImg (title) {
      if (title === ''){
        return ''
      }
      let index = this.lottery_imgs.findIndex((item) => item.title === title)
      if (index >= 0) {
        return this.lottery_imgs[index].img
      } else {
        return '';
      }
    },
    // 格式化奖品内容
    formatLottery (datas) {
      if (datas == '') {
        return false
      }
      let tlotterys = [];
      datas.forEach((item,index) => {
          item.img = this.getLotteryImg(item.image);
          item.class = 'prize-item';
          item.status = 2;
          item.select = 0;
          tlotterys.push(item)
          // 加入抽奖按钮
          if (index === 3) 
          {
            let temp = {
              id: 0,
              title: this.prize_draw_but.title,
              intro: this.prize_draw_but.subtitle,
              image: '',
              img:'',
              lottery_type: 0,
              class: 'prize-item prize-btn',
              click: '', // 点击事件
              select: 0, //是否选中
              status: parseInt(this.prize_draw_but.play_video_status),  // 0 不用播放视频 1 需要播放视频 2 不允许点击
            };

            // 获取当前抽奖状态
            if (temp.status === 0) {
              temp.class = 'prize-item prize-btn free-btn'
            } else if (temp.status === 2) {
              temp.class = 'prize-item prize-btn forbid-btn'
            } else {
              temp.class = 'prize-item prize-btn'
            }
            tlotterys.push(temp)
          }
      })
      this.lotterys = [];
      tlotterys.forEach((item,index) => {
        // 将上一次的奖品设置成选中
        let selectIndex = this.numArr[this.tempNum]
        if (selectIndex == index && this.prizeId == parseInt(item.id)) {
          item.select = 1
        }
        this.$set(this.lotterys, index, item)
      });
    },
    // 展示广告
    showAds() {
      console.log("开始播放广告");
      this.rloadShow = true;
      let params = {
        adType: "4", // 4 激励视频
        adCode: "", // 广告代码位
        tips: this.tipsConfigTxt
      };
      this.callClienFunc("playH5Ad", params);
    },
    getData(type) {
      let params = {
        userid: this.userid,
      };
      // http://gametest.lushihudong.com/api/user_web/day_red_envelopes_index
      this.isLoad = type === 1 ? true : false; // type = 2 不显示加载框
      this.$http
        .get(
          "http://game.lushihudong.com/api/user_web/lottery_index",
          {
            params: params
          }
        )
        .then(res => {
 
          this.lotterys = []; // 清除历史奖品数据
          if (res.code == 1) {

            if (res.data.rule_txt) {
              this.ruleTxt = res.data.rule_txt; //活动规则
            }
          
            this.prize_draw_but = res.data.prize_draw_but  //抽奖按钮状态及显示

            if (type == 1) {
              // 更新奖品信息列表
              this.formatLottery(res.data.lottery_labels)
              this.lottery_records = res.data.lottery_record
              this.tempLotteryLabels = res.data.lottery_labels;
            } else {
              // ==2 是 静默刷新 并且暂不显示更新记录 并且暂不更新奖品列表
              this.temp_records = res.data.lottery_record
              this.formatLottery(this.tempLotteryLabels)
              this.tempLotteryLabels = res.data.lottery_labels;
            }
          } else {
            this.toast("查询失败:" + res.message); //弹出错误信息
          }
          this.isLoad = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  font-family:PingFang-SC-Regular,Helvetica Neue,Helvetica,microsoft yahei,sans-serif;
  position: relative;
  display: block;
  width: 100%;
  max-width: 3.75rem;
  min-height: 100vh;
  background-image: linear-gradient(180deg, #FF2E2E 0%, #FF3C37 32%, #FF9F76 72%, #FCEBCA 100%);
  overflow: hidden;

  /** 顶部 */
  .header {
    position: absolute;
    display: flex;
    top: 0.38rem;
    width: calc(100% - 0.32rem);
    height: 0.22rem;
    padding: 0 0.16rem;
    justify-content: space-between;
    align-items: center;
    z-index: 72;

    /** 返回|退出按钮 */
    .go-back {
      display: block;
      width: 0.09rem;
      height: 0.16rem;
      background: url("~@/assets/images/high_reward/back.png");
      background-size: 0.09rem 0.16rem;
    }
    /** 顶部标题 */
    .top-title {
      font-size: 0.16rem;
      color: #fff;
      margin-left: 0.18rem;
    }
    /** 规则按钮 */
    .rule-btn {
      font-size: 0.14rem;
      color: #fff;
    }
  }

  /**红包内容 */
  .redpack-content {
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 100%;
    margin-top: 0.18rem;
    background: url("~@/assets/images/member_prize/bg.png") no-repeat;
    background-size: 3.75rem 5.3rem;


    /**标题 */
    .title {
      display: block;
      width: 2.3rem;
      height: 0.86rem;
      background: url("~@/assets/images/member_prize/title.png") no-repeat;
      background-size: 2.3rem 0.86rem;
      margin: 0.56rem 0 0 0;
    }
     /** 抽奖区域 */
    .prize-content{
      position: relative;
      z-index: 99;
      display: block;
      width: 3.51rem;
      height: 3.56rem;
      background: url("~@/assets/images/member_prize/prize_bg.png") no-repeat;
      background-size: 3.51rem 3.56rem;
       
      /** 抽奖奖品及按钮区域 */
      .prize-item-list {
        display: flex;
        flex-flow: wrap;
        width: 2.72rem;
        height: 2.72rem;
        margin: .55rem 0 0 .4rem;

        /** 抽奖奖品单元 */
        .prize-item {
          position: relative;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;
          align-items: center;
          width: .88rem;
          height: .88rem;
          margin: 0 0.04rem 0.04rem 0;
          background: url("~@/assets/images/member_prize/item_bg1.png") no-repeat;
          background-size: 0.88rem 0.88rem;
          span:first-child {
            img {
              width: .38rem;
              height: .38rem;
            }
          }
          span:nth-child(2) {
            font-size: .12rem;
            color: #FF3F51;
          }
          span:nth-child(3) {
            font-size: .10rem;
            color: #FF3F51;
          }
          span:nth-child(4) {
            position: absolute;
            width: .88rem;
            height: .88rem;
            background: url("~@/assets/images/member_prize/item_bg_select.png") no-repeat;
            background-size: 0.88rem 0.88rem;
          }
        }
        /** 抽奖按钮 */
        .prize-btn
        {
          position: relative;
          background: url("~@/assets/images/member_prize/item_bg.png") no-repeat;
          background-size: 0.95rem 0.95rem;
          background-position: -0.045rem -0.045rem;
          width: 0.86rem;
          height: 0.88rem;
          padding-right: 0.02rem;
          margin: 0 0.032rem 0.04rem 0.008rem;
          animation: breathe 1.3s ease-in-out infinite;
          border: 0 none;
          box-shadow: none;
          border-radius: 0;
          span:nth-child(2) {
            text-align: center;
            width: 0.48rem;
            line-height: .2rem;
            font-size: .16rem;
            color: #FFF8E8;
            margin-top: -0.02rem;
            margin-bottom: 0.015rem;
            text-shadow: 0 0.02rem 0.04rem rgba(255,0,0,0.61);
          }
          span:nth-child(3) {
            font-size: .10rem;
            color: #FFF8E8;
          }
        }
        /** 呼吸灯动画 */
        @keyframes breathe {
            0%, 100% {
                transform: scale(0.92); /* 原始大小 */
            }
            50% {
                transform: scale(1.01); /* 稍微放大 */
            }
        }
        /** 悬停时停止动画 */
        .prize-btn:hover
        {
          animation-play-state: paused;
        }
        
        /**奖品背景图片及间距的设置 */
        .prize-item:nth-child(3), .prize-item:nth-child(6), .prize-item:nth-child(9)
        {
          margin-right: 0rem;
        }
        .prize-item:nth-child(7), .prize-item:nth-child(8), .prize-item:nth-child(9)
        {
          margin-bottom: 0rem;
        }

        .prize-item:nth-child(2), .prize-item:nth-child(4), .prize-item:nth-child(6), .prize-item:nth-child(8)
        {
          background: url("~@/assets/images/member_prize/item_bg2.png") no-repeat;
          background-size: 0.88rem 0.88rem;
        }

        /**抽奖次数为0 禁止抽奖样式 */
        .forbid-btn {
          animation-play-state: paused;// 禁止抽奖 呼吸灯效果停止
          span:nth-child(1){
            position: absolute;
            top:0rem;
            left:0.0015rem;
            display: block;
            width: .87rem!important;
            height: .88rem!important;
            background: rgba(0,0,0,0.28);
            border-radius: .88rem;
          }
        }

        /**初始免费抽奖按钮样式 */
        .free-btn {
          span:nth-child(2) {
            font-size: .24rem!important;
            line-height: .28rem!important;
          }
        }
      }
    }
    /**奖励记录 */
    .prize-record {
      display: block;
      width: 3.75rem;
      min-height: 3rem;
      margin-top: -0.14rem;
      .prize-record-title {
        display: block;
        width: 3.75rem;
        height: .6rem;
        background: url("~@/assets/images/member_prize/record-top.png") no-repeat;
        background-size: 3.75rem 0.6rem;
      }
      .prize-record-content {
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        height: 2.3rem;
        padding-bottom: .2rem;
        background: #FF4E0C;
        .prize-record-top {
          position: absolute;
          top: 0;
          left: calc((100% - 1.42rem)/2);
          width: 1.42rem;
          height: 0.36rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: linear-gradient(180deg, #FFB264 0%, #FF6C1A 100%);
          border-radius: 0 0 .1rem .1rem;
          font-size: .18rem;
          color: #FFFFFF;
        }
        /** 奖励记录 */
        .prize-record-list {
          display: flex;
          flex-flow: column;
          padding: .50rem 0.14rem 0.14rem 0.14rem;
          background: #FFEAC1;
          box-shadow: inset 0 .01rem .03rem 0 #B9250C;
          border-radius: .1rem;
          width: 3.07rem;
          height: 1.6rem;
          .prize-record-list-box {
            display: flex;
            flex-flow: column;
            height: 1.6rem;
            overflow-y: auto;
          }
          .prize-record-list-item {
            display: flex;
            justify-content: flex-start;
            font-size: .14rem;
            color: #FF5032;
            span {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              height: .4rem;
            }
            span:first-child {
              margin-right: .1rem;
              padding-top:.01rem;
              height: 0.39rem;
              width: .7rem;
            }
            span:nth-child(2) {
              display: block;
              text-align: left;
              line-height: .4rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  /**规则弹窗 */
  .introduce {
    position: relative;
    display: flex;
    justify-content: center;
    width: 3.4rem;
    height: 4.4rem;
    background: url("~@/assets/images/member_prize/rule_bg.png") no-repeat;
    background-size: 3.4rem 3.9rem;
    overflow: hidden;
    .close {
      position: absolute;
      display: flex;
      width: 0.24rem;
      height: 0.24rem;
      background: url("~@/assets/images/member_prize/close.png") no-repeat;
      background-size: 0.24rem 0.24rem;
      bottom: 0rem;
    }
    .rule_info {
      display: flex;
      width: 100%;
      height: 2.1rem;
      margin: 1.46rem 0.6rem 0.84rem 0.6rem;
      overflow-y: auto;
      div:first-child {
        display: flex;
        font-size: 0.14rem;
        color: #333;
        line-height: 0.2rem;
      }
    }
  }

  /**中奖结算弹窗 */
  .reward-content {
    position: relative;
    display: flex;
    justify-content: center;
    width: 3.4rem;
    height: 4.4rem;
    background: url("~@/assets/images/member_prize/reward_bg.png") no-repeat;
    background-size: 3.4rem 3.9rem;
    overflow: hidden;
    .close {
      position: absolute;
      display: flex;
      width: 0.24rem;
      height: 0.24rem;
      background: url("~@/assets/images/member_prize/close.png") no-repeat;
      background-size: 0.24rem 0.24rem;
      bottom: 0rem;
    }
    .reward-info {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 2.2rem;
      margin: 1.36rem 0.6rem 0.84rem 0.6rem;
      span:first-child {
        width: 0.8rem;
        height: 0.8rem;
        img {
          width: 0.8rem;
          height: 0.8rem;
        }
      }
      span:nth-child(2) {
        font-size: .18rem;
        color: #FF3F51;
        font-weight: 600;
        margin: .05rem 0;
      }
      span:nth-child(3) {
        font-size: .14rem;
        color: #333;
      }
      span:nth-child(4) {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 2.08rem;
        height: 0.48rem;
        background: #FF5032;
        box-shadow: 0 0.01rem 0.1rem 0 #FF5032;
        border-radius: .24rem;
        font-size: .18rem;
        color: #FFEDBE;
        font-weight: 600;
        margin: .12rem 0;
      }
      span:nth-child(5) {
        font-size: .16rem;
        color: #FF5032;
        font-weight: 600;
      }
    }
  }
  /** 红包加载中弹窗 */
  .redpack-loading {
    display: flex;
    flex-flow: column;
    align-items: center;
    span:first-child {
      margin-bottom: 0.22rem;
      img {
        width: 0.64rem;
        height: 0.75rem;
      }
    }
    span:nth-child(2),
    span:nth-child(3) {
      margin-bottom: 0.06rem;
      font-size: 0.16rem;
      color: #ffffff;
      width: 2rem;
      text-align: center;
    }
  }
}
/deep/.van-popup {
  background: transparent;
}
</style>